<template>
  <div :class="'e-form ' + formClass">
    <e-perfect-scrollbar
      v-if="enablePerfectScrollbar"
      :updateStreamName="scrollUpdateStreamName"
      :emitTypes="['rxjs']"
    >
      <slot></slot>
    </e-perfect-scrollbar>
    <slot v-else></slot>
  </div>
</template>

<script>
  export default {
    name: 'e-form',
    props: {
      formClass: {
        type: String,
        default: 'body-wrapper cuscroll'
      },
      errors: null,
      formValidator: null,
      enablePerfectScrollbar: {
        type: Boolean,
        default: true
      },
      scrollUpdateStreamName: {
        type: String,
        default: null
      }
    }
  }
</script>
